export function setTrackerCustomerSystemId (externalId) {
  if (typeof window === 'undefined' || externalId == null) {
    return false
  }

  const ocapi = window.ocapi

  if (!ocapi || typeof ocapi.setCustomerSystemId !== 'function') {
    return false
  }

  ocapi.setCustomerSystemId(externalId)

  return true
}

export function trackPageView () {
  if (typeof window === 'undefined') {
    return false
  }

  const ocapi = window.ocapi

  if (!ocapi || typeof ocapi.event !== 'function') {
    return false
  }

  ocapi.event('page_view')

  return true
}
